// Page section helpers
import React from "react";

export const Section = ({ id, dark, children, className = "" }) => (
  <section
    id={id}
    className={`py-16 lg:py-24 ${dark ? "bg-[var(--jt-ink)] text-white" : ""} ${className}`}
  >
    <div className="jt-container">{children}</div>
  </section>
);

export const SectionHead = ({ eyebrow, title, intro, align = "left", dark = false, action }) => (
  <div
    className={`mb-10 lg:mb-14 flex flex-col ${align === "center" ? "items-center text-center" : ""}`}
  >
    <div className="flex items-end justify-between w-full gap-6">
      <div>
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        <h2 className={`font-display font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-2 ${dark ? "text-white" : ""}`}>
          {title}
        </h2>
      </div>
      {action}
    </div>
    {intro ? (
      <p className={`mt-4 max-w-2xl text-base leading-relaxed ${dark ? "text-white/70" : "text-[var(--jt-text-muted)]"}`}>{intro}</p>
    ) : null}
  </div>
);

export const PageHero = ({ eyebrow, title, intro, breadcrumbs }) => (
  <section className="bg-[var(--jt-ink)] text-white relative overflow-hidden">
    <div className="absolute inset-0 jt-placeholder-dark opacity-50" aria-hidden="true" />
    <div className="jt-container relative py-14 lg:py-20">
      {breadcrumbs ? (
        <div className="font-mono text-[0.7rem] tracking-widest uppercase text-white/50 mb-3" data-testid="page-breadcrumbs">
          {breadcrumbs}
        </div>
      ) : null}
      {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
      <h1 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-2 max-w-4xl">
        {title}
      </h1>
      {intro ? <p className="mt-4 text-white/70 max-w-2xl text-lg leading-relaxed">{intro}</p> : null}
    </div>
  </section>
);
